export default {
  'build.info': 'Build-Informationen',
  'build.mode': 'Modus',
  'build.framework': 'Framework',
  'build.os': 'Betriebssystem',
  'build.osPlatform': 'Plattform',
  'build.osRelease': 'Release',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',
  'theme.system': 'System',
  'theme.tooltip': 'Thema',
};
